import SignInAsGuest from './SignInAsGuest';

export default SignInAsGuest;
